import { BASE_URL_API } from "constants/base-url-api";
import { getCookie } from "utils/functions-cookie";

export type Root = {
  brand: string;
  holder: string;
  card_number: string;
  expiration_date: string;
};


export const updatePaymentData = async (recurrentId: string, data: Root) => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }

  const response = await fetch(`${BASE_URL_API}/payments/${recurrentId}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    },    
    body: JSON.stringify(data),
  });

  if(response.status === 422){
    throw new Error("Dados informados são inválidos.")
  }

  if (response.status !== 200) {
      const { detail } = (await response.json()) as { detail: string };
    throw new Error(detail ??  "Erro ao atualizar dados de pagamento");
  }
};
